export default "__VITE_ASSET__C8E6LW1H__"